import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalSetupForm from './GlobalSetupForm';
import { fetchGlobalSetup } from '../store/globalSetup';

import './GlobalSetup.scss';

export const GLOBAL_SETUP_ROUTE = '/globalSetup';

const GlobalSetup = () => {
    const dispatch = useDispatch();
    /** @type {GlobalSetup.GlobalSetupStore} */
    // @ts-ignore
    // eslint-disable-next-line max-len
    const { 
        globalSetupAppData: { 
            isGlobalSetupDataLoaded,
            reset,
            ...globalSetupAppData 
        }
    } = useSelector((state) => state);
    const [setups, setGlobalSetups] = useState(globalSetupAppData);

    useEffect(() => {
        if (!isGlobalSetupDataLoaded) {
            dispatch(fetchGlobalSetup());
        }
    }, []);

    useEffect(() => {
        setGlobalSetups(globalSetupAppData);
    }, [JSON.stringify(globalSetupAppData)]);

    return (
        <div className="admin--global-setup">
            <GlobalSetupForm
                isGlobalSetupLoaded={isGlobalSetupDataLoaded}
                globalSetups={setups}
                globalSetupsToReset={reset}
            />
        </div>
    );
};

export default GlobalSetup;
